/**
 * Candidate selection for the AI Scanner results step (STORY-013).
 *
 * Deliberately a seam, not an algorithm: the results UI ships ahead of the
 * Q1/Q2 scoring, so this takes the head of the STORY-008 filtered set in its
 * existing order. STORY-010 replaces the body with real ranking without the
 * results view having to change.
 */

/**
 * Maximum candidates rendered. Requirements allow 3-5 (NFR 13, never 1); the
 * placeholder selection takes the minimum so it never over-promises against
 * a set that scoring would have narrowed.
 *
 * Stays within `MAX_SUMMARY_SYMBOLS` (summarizePayload). The container
 * prefetches symbol metadata for that many symbols when the questions step
 * opens, and `ScanResults` reads the names straight from the store rather
 * than fetching its own — a candidate outside that window would render as a
 * raw symbol ID. Both bounds trace back to NFR 13's maximum of 5, so they
 * move together rather than drifting.
 */
export const CANDIDATE_COUNT = 3;

/**
 * @param {string[]} [filtered] - Symbol IDs from the hashtag filter, in the
 *   order the filter produced them.
 * @returns {string[]} Up to {@link CANDIDATE_COUNT} symbol IDs.
 */
export const selectCandidates = (filtered) =>
  Array.isArray(filtered) ? filtered.slice(0, CANDIDATE_COUNT) : [];

export default selectCandidates;
